import api from "../api";

export const getTasks = (filter = null) => {
  const url = filter
    ? `${api.getBaseUrl()}tasks?filter=${filter}`
    : `${api.getBaseUrl()}tasks`;
  return api.getApi().get(url);
};

export const getTask = (id) => {
  return api.getApi().get(api.getBaseUrl() + "tasks/" + id);
};

export const createTask = (data) => {
  return api.getApi().post(api.getBaseUrl() + "tasks", data);
};

export const updateTask = (id, data) => {
  return api.getApi().put(api.getBaseUrl() + "tasks/" + id, data);
};

export const deleteTask = (id) => {
  return api.getApi().delete(api.getBaseUrl() + "tasks/" + id);
};

export const addTaskComment = (taskId, content) => {
  return api.getApi().post(api.getBaseUrl() + "tasks/" + taskId + "/comments", {
    content,
  });
};

export const updateTaskStatus = (taskId, status) => {
  return api.getApi().put(api.getBaseUrl() + "tasks/" + taskId + "/status", {
    status,
  });
};

export const getMyTaskCount = () => {
  return api.getApi().get(api.getBaseUrl() + "tasks/count/my-tasks");
};
